import { TypedMoney } from "@swo/storefront";
import { ReadonlyNonEmptyArray } from "fp-ts/ReadonlyNonEmptyArray";
import { useMemo } from "react";
import { FrontendProductCarouselElem } from "./PDPProductsCarouselComponent";
import { ProductView } from "./ProductView";

export function useCarouselElements(
  elements: ReadonlyNonEmptyArray<FrontendProductCarouselElem>,
  localisedShowPrice: (m: TypedMoney) => string,
  background: "transparent" | "grey",
) {
  return useMemo(() => {
    return elements.map(e => {
      const linkTo = e.internalLink ? { pathname: e.internalLink, state: { scrollToTop: true } } : undefined;

      return (
        <ProductView
          linkTo={linkTo}
          background={background}
          localisedShowPrice={localisedShowPrice}
          image={e.image}
          headline={e.headline}
          price={e.price}
        />
      );
    });
  }, [JSON.stringify(elements)]);
}
